import React from "react";
import SuccessModal from "../../../CustomAlerts/SuccessModal";

const KycVerification = () => {
  return (
    <div>
      <SuccessModal
        msg={"Please allow the compliance team up to 48 business hours to review."}
        route={"/"}
      />
    </div>
  );
};

export default KycVerification;
